const FormActionConstants = {
	// Form Editor
	ADD_FIRST_ELEMENT: 'ADD_FIRST_FORM_ELEMENT',
	ADD_INPUT_TO_GROUP: 'ADD_INPUT_TO_GROUP',
	ADD_CUSTOM_ANSWER_FIELD_TO_GROUP: 'ADD_CUSTOM_ANSWER_FIELD_TO_GROUP',
	ADD_OPTION_TO_SELECT_MENU: 'ADD_OPTION_TO_SELECT_MENU',
	ADD_ROW: 'ADD_FORM_ROW',
	ADD_TABLE_COLUMN: 'ADD_TABLE_COLUMN',
	ADD_TABLE_ROW: 'ADD_TABLE_ROW',
	BULK_REPLACE_OPTIONS: 'BULK_REPLACE_OPTIONS',
	CHANGE_TITLE: 'CHANGE_FORM_TITLE',
	CHANGE_URL: 'CHANGE_FORM_URL',
	CLEAR_EDIT_MODE: 'CLEAR_EDIT_MODE',
	INITIALIZE: 'INITIALIZE_NEW_FORM',
	INITIALIZE_TEMPLATE_FORM: 'INITIALIZE_TEMPLATE_FORM',
	INITIALIZE_INPUT_GROUP: 'INITIALIZE_INPUT_GROUP',
	INITIALIZE_SELECT_MENU: 'INITIALIZE_SELECT_MENU',
	INITIALIZE_ADDRESS_STATES: 'INITIALIZE_ADDRESS_STATES',
	INITIALIZE_ADDRESS: 'INITIALIZE_ADDRESS',
	INITIALIZE_CONTACT: 'INITIALIZE_CONTACT',
	INITIALIZE_TABLE_ELEMENT: 'INITIALIZE_TABLE_ELEMENT',
	LOAD: 'LOAD_FORM',
	MOVE_ROW: 'MOVE_FORM_ROW',
	MOVE_INPUT_FROM_GROUP: 'MOVE_INPUT_FROM_GROUP',
	REBUILD: 'REBUILD_FORM',
	REMOVE_ELEMENT: 'REMOVE_FORM_ELEMENT',
	REMOVE_CUSTOM_ANSWER_FIELD_FROM_GROUP: 'REMOVE_CUSTOM_ANSWER_FIELD_FROM_GROUP',
	REMOVE_INPUT_FROM_GROUP: 'REMOVE_INPUT_FROM_GROUP',
	REMOVE_OPTION_FROM_SELECT_MENU: 'REMOVE_OPTION_FROM_SELECT_MENU',
	REMOVE_ALL_OPTIONS_FROM_SELECT_MENU: 'REMOVE_ALL_OPTIONS_FROM_SELECT_MENU',
	REMOVE_ROW: 'REMOVE_FORM_ROW',
	REMOVE_SETTINGS_PROPERTY: 'REMOVE_FORM_SETTINGS_PROPERTY',
	REMOVE_TABLE_COLUMN: 'REMOVE_FORM_TABLE_COLUMN',
	REMOVE_TABLE_ROW: 'REMOVE_FORM_TABLE_ROW',
	SET_FORM_URL_STATE: 'SET_FORM_URL_STATE',
	SAVE_RICH_TEXT: 'SAVE_RICH_TEXT',
	SET_SAVE_BUTTON_STATE: 'SET_SAVE_BUTTON_STATE',
	SET_TABLE_ANSWER_STYLE: 'SET_TABLE_ANSWER_STYLE',
	TOGGLE_EDIT_MODE: 'TOGGLE_ELEMENT_EDIT_MODE',
	UPDATE_ELEMENT_MODEL: 'UPDATE_FORM_ELEMENT_MODEL',
	UPDATE_GROUPED_ELEMENT_LABEL: 'UPDATE_GROUPED_ELEMENT_LABEL',
	UPDATE_CUSTOM_GROUPED_ELEMENT_LABEL: 'UPDATE_CUSTOM_GROUPED_ELEMENT_LABEL',
	UPDATE_SELECT_MENU_OPTION_LABEL: 'UPDATE_SELECT_MENU_OPTION_LABEL',
	UPDATE_TABLE_COLUMN_LABEL: 'UPDATE_TABLE_COLUMN_LABEL',
	UPDATE_TABLE_ROW_LABEL: 'UPDATE_TABLE_ROW_LABEL',
	// Advanced Settings
	SAVE_SETTING: 'SAVE_SETTING',
	TEST: 'TEST_FORM_ACTIONS'
}

export default FormActionConstants;



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/shared/constants/actions/form.js